var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 274.3 84.9",
    style: {
      enableBackground: "new 0 0 274.3 84.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#199C48;stroke:#0B9C48;stroke-miterlimit:10;}\n\t.st1{fill:#199C48;}\n\t.st2{enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.8,16.3c-0.4-2.2-2.3-5-0.3-8.1S41.2,3.1,41,0c0,0,2.9,4.1,0.9,7.9C40,11.5,35.6,11.8,32.8,16.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.1,23.8c-1.5-1.6-4.6-3-4.7-6.7s4.6-9,2.8-11.5c0,0,4.7,1.9,5,6.1C24.5,15.8,21.1,18.5,21.1,23.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.4,36.4c-2.2-0.6-5.5,0-7.5-3.1S6.9,23.2,4,22.1c0,0,4.9-1,7.5,2.5C13.9,27.9,12.5,31.9,15.4,36.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.3,50.1c-2.1,0.7-4.7,3-8,1.5S3,43.6,0,44.3c0,0,3.6-3.5,7.7-2C11.5,43.7,12.5,47.9,17.3,50.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.4,60.5c-1.4,1.7-2.3,5-5.9,5.6S10.8,62.8,8.7,65c0,0,1.2-4.9,5.4-5.8C18,58.3,21.1,61.3,26.4,60.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.7,64.4c-0.3,2.2,0.8,5.5-2,7.9s-9.9,2.4-10.5,5.4c0,0-1.6-4.8,1.4-7.8C31.4,67.1,35.7,68,39.7,64.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.9,60.6c1,2,3.6,4.2,2.6,7.7s-7,7.4-5.9,10.3c0,0-4-3.1-3.1-7.3C47.4,67.2,51.5,65.7,52.9,60.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62,50.1c1.9,1.2,5.3,1.6,6.4,5.1S66.5,65.2,69,67c0,0-5-0.5-6.5-4.5C61,58.7,63.5,55.2,62,50.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64,36.4c2.2,0,5.3-1.5,8.1,0.8s3.8,9.4,6.9,9.6c0,0-4.5,2.3-7.9-0.2C67.8,44.2,68,39.9,64,36.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.2,23.8c1.8-1.2,3.7-4.2,7.3-3.7s8.3,5.9,11,4.4c0,0-2.5,4.4-6.8,4.1C65.6,28.3,63.5,24.5,58.2,23.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.6,16.3c0.9-2.1,0.8-5.5,4.1-7S60.9,9.8,62.3,7c0,0,0.2,5-3.5,7.1C55.2,16.1,51.4,14,46.6,16.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.8,16.3c-0.4-2.2-2.3-5-0.3-8.1S41.2,3.1,41,0c0,0,2.9,4.1,0.9,7.9C40,11.5,35.6,11.8,32.8,16.3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.3,
    y: 1.4,
    className: "st1",
    width: 2.2,
    height: 75.7
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.8,30.9l2.2-3.4c2.1,1.3,4.2,2,6.2,2c1.3,0,2.3-0.2,3.1-0.6c0.7-0.4,1.1-1,1.1-1.8 c0-0.5-0.1-0.9-0.4-1.2c-0.2-0.3-0.7-0.6-1.3-1c-0.6-0.3-1.5-0.7-2.7-1.2l-0.8-0.3c-1.5-0.6-2.6-1.1-3.5-1.6 c-0.9-0.5-1.6-1.2-2.1-2c-0.5-0.8-0.8-1.9-0.8-3.1c0-1.4,0.4-2.5,1.2-3.5c0.8-0.9,1.8-1.6,3.1-2c1.3-0.4,2.6-0.6,4-0.6 c1.3,0,2.6,0.2,3.9,0.6c1.4,0.4,2.6,1,3.9,1.9l-2.2,3.3c-1.1-0.7-2-1.1-2.9-1.4c-0.8-0.3-1.7-0.4-2.7-0.4c-1.1,0-1.9,0.2-2.5,0.5 c-0.6,0.4-0.8,0.9-0.8,1.5c0,0.4,0.1,0.7,0.3,1c0.2,0.3,0.6,0.6,1.2,0.9c0.6,0.3,1.4,0.7,2.5,1.1l0.7,0.3 c1.4,0.5,2.6,1.1,3.5,1.5c0.9,0.5,1.6,1.2,2.3,2c0.6,0.9,0.9,2,0.9,3.4c0,1.5-0.4,2.7-1.2,3.7c-0.8,1-1.8,1.8-3.2,2.3 c-1.3,0.5-2.8,0.8-4.5,0.8C146.1,33.6,143.2,32.7,140.8,30.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.4,11l8,21.8v0.3h-5.2l-1.8-5.3h-8.2l-1.7,5.3h-5.1v-0.3l8-21.8H174.4z M168.5,23.9h5.6l-2.8-8.4 L168.5,23.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.6,20.4v11.1c-1.5,0.8-3,1.3-4.3,1.7c-1.3,0.3-2.7,0.5-4.1,0.5c-3.7,0-6.4-1-8.2-3.1 c-1.7-2.1-2.6-4.8-2.6-8.3c0-2.7,0.5-4.9,1.5-6.6c1-1.7,2.3-3,4-3.8c1.7-0.8,3.5-1.2,5.7-1.2c1.4,0,2.7,0.2,4,0.5 c1.3,0.4,2.4,0.9,3.5,1.6l-2,3.4c-1.7-1-3.5-1.5-5.3-1.5c-2.1,0-3.7,0.6-4.8,1.9c-1,1.3-1.6,3.1-1.6,5.5c0,2.5,0.5,4.4,1.5,5.6 c1,1.2,2.5,1.9,4.7,1.9c1.2,0,2.3-0.2,3.3-0.5v-4.6h-4.7l0.5-3.9H202.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.5,13.5c2.1,1.7,3.2,4.5,3.2,8.5c0,2.5-0.6,4.5-1.7,6.2c-1.1,1.7-2.6,2.9-4.5,3.7s-3.9,1.2-6.1,1.2h-7.2 V11h7.4C219.4,11,222.4,11.8,224.5,13.5z M219.2,28.4c1.2-0.4,2-1.1,2.6-2.1c0.6-1,0.9-2.4,0.9-4.3c0-1.7-0.3-3.1-0.8-4.1 s-1.3-1.7-2.4-2.2c-1-0.4-2.4-0.7-4-0.7h-2.6v13.8h1.6C216.4,28.9,218,28.7,219.2,28.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M249.8,11v0.3l-8.2,12.6v9.2h-4.7V24l-8-12.8V11h5.5l5,8.5l5.2-8.5H249.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M272.6,11v22.1h-5.3l-7-10.3c-0.6-0.9-1.1-1.7-1.5-2.4c-0.4-0.7-0.8-1.4-1.2-2.3v14.9H253V11h5.2l7.6,11.3 c0.1,0.1,0.3,0.4,0.6,0.9c0.3,0.5,0.6,1,0.9,1.4c0.3,0.4,0.5,0.9,0.7,1.3V11H272.6z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.2,66.8c-1.4-0.8-2.5-2-3.1-3.4s-1-3-1-4.9V45.4h4.7V58c0,1.9,0.4,3.4,1.2,4.5c0.8,1.1,2.1,1.6,4,1.6 c1.8,0,3.1-0.5,3.9-1.6c0.7-1.1,1.1-2.4,1.1-4.1V45.4h4.7v13c0,2.3-0.4,4.1-1.3,5.5c-0.9,1.4-2,2.5-3.5,3.1s-3.2,1-5.2,1 C149.5,68,147.6,67.6,146.2,66.8z M147.4,42.9c-0.4-0.2-0.7-0.5-0.9-0.9c-0.2-0.4-0.3-0.8-0.3-1.2c0-0.4,0.1-0.8,0.3-1.2 c0.2-0.4,0.5-0.7,0.9-0.9c0.4-0.2,0.8-0.3,1.2-0.3c0.5,0,0.9,0.1,1.3,0.3c0.4,0.2,0.7,0.5,0.9,0.9c0.2,0.4,0.3,0.8,0.3,1.2 c0,0.4-0.1,0.8-0.3,1.2c-0.2,0.4-0.5,0.7-0.9,0.9c-0.4,0.2-0.8,0.3-1.3,0.3C148.1,43.2,147.7,43.1,147.4,42.9z M154,42.9 c-0.4-0.2-0.7-0.5-0.9-0.9c-0.2-0.4-0.3-0.8-0.3-1.2c0-0.4,0.1-0.8,0.3-1.2c0.2-0.4,0.5-0.7,0.9-0.9c0.4-0.2,0.8-0.3,1.2-0.3 c0.5,0,0.9,0.1,1.2,0.3c0.4,0.2,0.7,0.5,0.9,0.9c0.2,0.4,0.3,0.8,0.3,1.2c0,0.4-0.1,0.8-0.3,1.2c-0.2,0.4-0.5,0.7-0.9,0.9 c-0.4,0.2-0.8,0.3-1.2,0.3C154.8,43.2,154.4,43.1,154,42.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M171.9,63.4h10.2v4.2h-14.9V45.4h4.7V63.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196.4,55.9l9.2,11.4v0.3h-6l-8.6-11v11h-4.7V45.4h4.7v10.2l8.6-10.2h5.5v0.3L196.4,55.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.8,63.6h10.2v4h-14.9V45.4h14.8v3.9h-10.1v5h8.7l-0.6,3.9h-8.1V63.6z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo11);
export default __webpack_public_path__ + "static/media/logo11.23c4ef5d267a216845f98683f482e41a.svg";
export { ForwardRef as ReactComponent };